<section tuiContent>
	<h3 class="mb-2 text-2xl text-primary font-semibold">
		{{ prefix + '.percentile.label' | transloco }}
	</h3>

	<p
		class="mb-4"
		[innerHTML]="
			prefix + '.percentile.' + costType() + '.description' | transloco
		"
	></p>

	<section class="mb-8" tuiTableContainer>
		<table tuiTable>
			<tr>
				<td class="w-32">
					<mar-color-code-cell
						[value]="prefix + '.green' | transloco"
						color="green"
					/>
				</td>
				<td>
					{{ prefix + '.percentile.green-description' | transloco }}
				</td>
			</tr>
			<tr>
				<td class="w-32">
					<mar-color-code-cell
						[value]="prefix + '.yellow' | transloco"
						color="yellow"
					/>
				</td>
				<td>
					{{ prefix + '.percentile.yellow-description' | transloco }}
				</td>
			</tr>
			<tr>
				<td class="w-32">
					<mar-color-code-cell
						[value]="prefix + '.red' | transloco"
						color="red"
					/>
				</td>
				<td>
					{{ prefix + '.percentile.red-description' | transloco }}
				</td>
			</tr>
		</table>
	</section>

	<h3 class="mb-2 text-2xl text-primary font-semibold">
		{{ prefix + '.comparison.label' | transloco }}
	</h3>

	<p
		class="mb-4"
		[innerHTML]="
			prefix + '.comparison.' + costType() + '.description' | transloco
		"
	></p>

	<section tuiTableContainer>
		<table tuiTable>
			<tr>
				<td class="w-32">
					<mar-color-code-cell
						[value]="prefix + '.green' | transloco"
						color="green"
					/>
				</td>
				<td>
					{{
						prefix +
							'.comparison.' +
							costType() +
							'.green-description' | transloco
					}}
				</td>
			</tr>
			<tr>
				<td class="w-32">
					<mar-color-code-cell
						[value]="prefix + '.yellow' | transloco"
						color="yellow"
					/>
				</td>
				<td>
					{{
						prefix +
							'.comparison.' +
							costType() +
							'.yellow-description' | transloco
					}}
				</td>
			</tr>
			<tr>
				<td class="w-32">
					<mar-color-code-cell
						[value]="prefix + '.red' | transloco"
						color="red"
					/>
				</td>
				<td>
					{{
						prefix +
							'.comparison.' +
							costType() +
							'.red-description' | transloco
					}}
				</td>
			</tr>
		</table>
	</section>
</section>
